import { Tooltip } from "chart.js";

import { Modal } from "react-bootstrap";

export const RadarData = {
  labels: [
    "پایداری در برابر اصطکاک" ,
    "پایداری برشی",
    "مقاومت دربرابر اکسیداسیون",
    "مقاومت در برابر لرزش",
    "زمان تعویض روغن",
    "بروکفیلد پایینتر",
  ],
  datasets: [
    {
      label: "ATF II",
      backgroundColor: "rgba(185, 19, 19, .3)",
      borderColor: "rgba(185, 19, 196, 1)",
      pointBackgroundColor: "rgba(185, 19, 19, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(185, 19, 19, 1)",
      data: [2, 3, 2, 0, 2, 2],
    },
    {
      label: "ATF III G",
      backgroundColor: "rgba(50, 74, 185, .8)",
      borderColor: "rgba(50, 74, 185, .8)",
      pointBackgroundColor: "rgba(50, 74, 185, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(50, 74, 185, .8)",
      data: [4, 4, 3, 1, 3, 3],
    },
    {
      label: "ATF III H",
      backgroundColor: "rgba(19, 185, 44, .5)",
      borderColor: "rgba(19, 185, 44, .5)",
      pointBackgroundColor: "rgba(19, 185, 44, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(19, 185, 44, .5)",
      data: [6, 5, 5, 3, 6, 4],
    },
    {
      label: "ATF VI",
      backgroundColor: "rgba(232, 189, 33, .5)",
      borderColor: "rgba(232, 189, 33, .5)",
      pointBackgroundColor: "rgba(232, 189, 33, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(232, 189, 33, .5)",
      data: [8, 7, 5, 6, 6, 6],
    },
    {
      label: "ATF HP",
      backgroundColor: "rgba(200, 8, 221, .5)",
      borderColor: "rgba(200, 8, 221, .5)",
      pointBackgroundColor: "rgba(200, 8, 221, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(200, 8, 221, .5)",
      data: [8, 9, 8, 8, 10, 8],
    },
    {
      label: "ATF ULV",
      backgroundColor: "rgba(20,50, 120, .5)",
      borderColor: "rgba(20, 50, 120, .5)",
      pointBackgroundColor: "rgba(20, 50, 120, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(20, 50, 120, .5)",
      data: [10, 9, 10, 10, 10, 10],
    },
    {
      label: "ALISON TES -295",
      backgroundColor: "rgba(248, 205, 63, .8)",
      borderColor: "rgba(248, 205, 63, .8)",
      pointBackgroundColor: "rgba(248, 205, 63, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(248, 205, 63, .8)",
      data: [10, 10, 10, 0, 10, 10],
    },
  ],
};
export const RadarOptions = {
  scale: {
    ticks: {
      min: 0,
      max: 10,
      stepSize: 2,
      showLabelBackdrop: false,
      backdropColor: "rgba(203, 197, 11, 1)",
    },
    angleLines: {
      color: "#C3C3C4",
      lineWidth: 1,
    },
    gridLines: {
      color: "#C3C3C4",
      linear: true,
    },
    pointLabels: {
      fontSize: 18
    }
  },
};
